import { SVGProps } from 'react'

export const Sidebar = ({
  size = 24,
  className,
  ...props
}: SVGProps<SVGSVGElement> & { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    className={className}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21 3H3V21H21V3ZM4.5 19.5V4.5H14.5V19.5H4.5ZM16 19.5H19.5V4.5H16V19.5Z"
      fill="currentColor"
    />
  </svg>
)
